import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
import { useRoute, useRouter } from 'vue-router';
export default /*#__PURE__*/_defineComponent({
  __name: 'proto-pagination',
  props: {
    align: {
      type: String,
      default: 'right'
    },
    total: {
      type: Number,
      default: 50
    },
    layout: {
      type: String,
      default: 'total, prev, pager, next'
    },
    page: {
      type: Object,
      default: () => ({
        pageSize: 10,
        page: 1
      })
    }
  },
  emits: ['currentChange'],
  setup(__props, {
    emit: __emit
  }) {
    const route = useRoute();
    const router = useRouter();
    const emit = __emit;
    const props = __props;
    const handleSizeChange = size => {
      console.log('size', size);
    };
    const handleCurrentChange = val => {
      // console.log('val', val)
      emit('currentChange', val);
    };
    return (_ctx, _cache) => {
      const _component_el_pagination = _resolveComponent("el-pagination");
      return __props.total > __props.page.pageSize ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["proto-pagination", {
          center: __props.align === 'center',
          left: __props.align === 'left',
          right: __props.align === 'right'
        }])
      }, [_createVNode(_component_el_pagination, {
        background: "",
        layout: __props.layout,
        total: __props.total,
        "current-page": __props.page.page,
        "onUpdate:currentPage": _cache[0] || (_cache[0] = $event => __props.page.page = $event),
        "page-size": __props.page.pageSize,
        "onUpdate:pageSize": _cache[1] || (_cache[1] = $event => __props.page.pageSize = $event),
        onSizeChange: handleSizeChange,
        onCurrentChange: handleCurrentChange
      }, null, 8, ["layout", "total", "current-page", "page-size"])], 2)) : _createCommentVNode("", true);
    };
  }
});